@if (cardData) {
  <div class="card-with-value">
    <div class="card-header-container">
      <img [src]="'/public/assets/images/' + cardData.img" [alt]="cardData.id + 'icon'" />
      <span>{{ cardData.textsPointer + cardData.id | translate }}</span>
    </div>
    <p>{{ cardData.value }}</p>
    <nz-divider></nz-divider>
    <div class="card-footer-container">
      <span>{{ cardData.textsPointer + 'subtitle' | translate }} {{ cardData.secondValue }}</span>
      <img (click)="actionButton()" src="/public/assets/images/PlusCircleBlue.svg" alt="plus icon" />
    </div>
  </div>
}

